import React, { useState } from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Textarea } from './ui/textarea';
import { Input } from './ui/input';
import { MessageSquare, Send } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { toast } from 'sonner';

const ContactSection = () => {
  const { language } = useLanguage();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!message.trim()) {
      toast.error(language === 'fr' ? 'Veuillez écrire un message' : 'Please write a message');
      return;
    }

    const subject = encodeURIComponent('Commentaire monsaintpatron.org');
    const body = encodeURIComponent(
      `${language === 'fr' ? 'Nom' : 'Name'}: ${name || 'Non spécifié'}\n` +
      `${language === 'fr' ? 'Courriel' : 'Email'}: ${email || 'Non spécifié'}\n\n` +
      `${language === 'fr' ? 'Message' : 'Message'}:\n${message}`
    );
    
    window.location.href = `mailto:mb@deneversbox.com?subject=${subject}&body=${body}`;
    
    // Clear form
    setName('');
    setEmail('');
    setMessage('');
    
    toast.success(
      language === 'fr' 
        ? 'Ouverture de votre application de courriel...' 
        : 'Opening your email application...'
    );
  };

  return (
    <section className="py-16 bg-gradient-to-b from-secondary/30 to-background">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <div className="p-3 bg-gold/10 rounded-full">
              <MessageSquare className="w-8 h-8 text-gold" />
            </div>
          </div>
          <h2 className="font-heading text-2xl sm:text-3xl text-foreground mb-2">
            {language === 'fr' ? 'Vos Commentaires' : 'Your Feedback'}
          </h2>
          <p className="text-muted-foreground">
            {language === 'fr' 
              ? 'Partagez vos suggestions, témoignages ou questions' 
              : 'Share your suggestions, testimonials or questions'}
          </p>
        </div>

        <Card className="card-divine">
          <CardContent className="pt-6">
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-foreground mb-1">
                    {language === 'fr' ? 'Votre nom (optionnel)' : 'Your name (optional)'}
                  </label>
                  <Input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder={language === 'fr' ? 'Jean Dupont' : 'John Doe'}
                    className="bg-background"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-foreground mb-1">
                    {language === 'fr' ? 'Votre courriel (optionnel)' : 'Your email (optional)'}
                  </label>
                  <Input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="exemple@courriel.com"
                    className="bg-background"
                  />
                </div>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-foreground mb-1">
                  {language === 'fr' ? 'Votre message' : 'Your message'} *
                </label>
                <Textarea
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder={language === 'fr' 
                    ? 'Écrivez votre commentaire, suggestion ou témoignage ici...' 
                    : 'Write your comment, suggestion or testimonial here...'}
                  className="bg-background min-h-[120px]"
                  required
                />
              </div>

              <div className="flex justify-center pt-2">
                <Button 
                  type="submit" 
                  variant="sacred" 
                  size="lg" 
                  className="gap-2"
                  data-testid="send-comment-btn"
                >
                  <Send className="w-5 h-5" />
                  {language === 'fr' ? 'Envoyer le message' : 'Send message'}
                </Button>
              </div>
            </form>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default ContactSection;
